import { useQuery } from '@tanstack/react-query';
import { getBtc15ShadowExitPolicyReport } from '../lib/apiClient';

// The underlying take-profit history only changes when a round settles (at
// most every 15 minutes), so there's no value in polling anywhere near as
// often as the main predictor query does — same reasoning as
// useBtc15FittedModels.
const STALE_TIME_MS = 10 * 60_000;

/**
 * Retrospective-only: how each shadowed exit policy would have scored
 * against the same settled rounds. Never affects which policy is actually
 * live (see src/lib/shadowExitPolicyReport.ts).
 */
export function useBtc15ShadowExitPolicyReport() {
  return useQuery({
    queryKey: ['btc15-shadow-exit-policy-report'],
    queryFn: getBtc15ShadowExitPolicyReport,
    staleTime: STALE_TIME_MS,
    refetchInterval: STALE_TIME_MS,
  });
}
